{
    "TeamsAuth_UserIntro": "Bonjour **{}**,",
    "TeamsAuth_UserIntro_2": "Akixi pour MS Teams demande l'accès à votre locataire Microsoft Entra.",
    "TeamsAuth_AdminConsent": "Consentement de l'administration de la subvention",
    "TeamsAuth_Authorise": "Autoriser",
    "TeamsAuth_ConsentedMessage": "Consentement administratif accordé, veuillez cliquer sur Autoriser pour continuer",
    "TeamsAuth_AuthorisedMessage": "Autorisation accordée",
    "TeamsAuth_Decline": "Déclin",
    "TeamsAuth_Error_Unknown": "Une erreur non reconnue s'est produite. Veuillez réessayer. Si le problème persiste, veuillez contacter votre administrateur système.",
    "NAME": "TeamsAuth",
    "TeamsAuth_Authoriser_Select_Title": "Quels utilisateurs souhaitez-vous synchroniser depuis votre locataire Microsoft Entra ?",
    "TeamsAuth_Authoriser_Select_Options_Tenant": "Tous les utilisateurs concernés du locataire",
    "TeamsAuth_Authoriser_Select_Options_SecurityGroups": "Groupes de sécurité sélectionnés uniquement",
    "TeamsAuth_SecurityGroups_Loader_Title_1": "Obtention des groupes de sécurité",
    "TeamsAuth_SecurityGroups_Loader_Title_2": "Cela ne devrait pas prendre longtemps, veuillez patienter...",
    "TeamsAuth_SecurityGroups_Title": "Veuillez sélectionner vos groupes de sécurité",
    "TeamsAuth_SecurityGroups_SecurityGroup_NothingToSee": "Aucun groupe de sécurité n'a été trouvé...",
    "TeamsAuth_SecurityGroups_SecurityGroup": "[IDENTIFIANT: {}]",
    "TeamsAuth_SecurityGroups_Note": "Remarque : les groupes de sécurité peuvent être mis à jour ultérieurement.",
    "TeamsAuth_SecurityGroups_SyncAndClose": "Synchroniser et fermer",
    "TeamsAuth_SecurityGroups_NoSecurityGroups": "Synchronisation de l'ensemble du locataire"
}